import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { CompanyTypeData } from '../../../company/types/company-type-data';

export abstract class CompaniesAppBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getCompanyTypes(): Promise<CompanyTypeData[]>;
  public abstract getNumberOfCompaniesInContainer(companyIds: Array<{ _id: string }>): Promise<number>;
  public abstract removeCompanyRecords(companyIds: Array<{ _id: string }>): Promise<object>;
}
